import dayjs from "dayjs";

const PAYFILE_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export function formatPayfileDateRange(dateFromValue, dateToValue) {
  return {
    from: dateFromValue
      ? dayjs(dateFromValue).startOf("day").format(PAYFILE_DATE_FORMAT)
      : null,
    to: dateToValue
      ? dayjs(dateToValue).endOf("day").format(PAYFILE_DATE_FORMAT)
      : null,
  };
}

export function isPayfileDateRangeWithinLimit(dateFromValue, dateToValue) {
  return (
    !dateFromValue ||
    !dateToValue ||
    !dayjs(dateToValue).isAfter(dayjs(dateFromValue).add(30, "day"))
  );
}
